import React, { useState, useEffect } from 'react'
import styles from './styles.module.scss'
import { useDispatch, useSelector } from 'react-redux'
import { generalFeedActions } from 'srcReact/FeedPage/actions'
import { getCurrentOrgId } from 'srcReact/helpers/organizationHelper'
import { getWorkplaceIds } from 'srcReact/helpers/workplaceHelper'
import useInfinitScroll from 'srcReact/helpers/hooks/useInfinitScroll'
import Avatar from 'srcReact/components/common2/Avatar'
import WorkplaceTile from 'srcReact/components/common2/WokplaceTile'
import Spinner from 'srcReact/components/common2/Spinner'
import { lightProfileActions } from 'srcReact/components/common2/LightProfileModal/actions'
import LightProfileProto from 'srcReact/components/common2/LightProfileModal/LightProfilPrototype'

function CTANewMembersFull() {
  const dispatch = useDispatch()
  const [orgId, setOrgId] = useState(0)
  const [wpIds, setWpIds] = useState('')
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [pagination, setPagination] = useState({
    nextOffset: 0,
    isPagination: false
  })

  const {
    common: { isNative },
    feedHome: {
      ctas: {
        new_members: { workplaces },
        new_members_paginated: { new_members, stats, loading }
      }
    },
    organization: { current_organization }
  } = useSelector((state) => state)

  useEffect(() => {
    const organizationId = getCurrentOrgId()
    const workplaceIds = getWorkplaceIds(current_organization)
    setOrgId(organizationId)
    setWpIds(workplaceIds)
    dispatch(generalFeedActions.getNewMembersCTA(organizationId, workplaceIds, 'new_members', 0, false))
  }, [])

  useEffect(() => {
    if (pagination.isPagination) {
      dispatch(generalFeedActions.getNewMembersCTA(orgId, wpIds, 'new_members', stats.next_offset, true))
    }
  }, [pagination])

  const lastMemberRef = useInfinitScroll(loading, stats && stats.remaining, stats && stats.next_offset, setPagination, [
    loading
  ])

  const showUserModal = (userId) => {
    const lp = new LightProfileProto()
    lp.userId = userId
    dispatch(lightProfileActions.openLightProfileModal(lp))
  }

  return (
    <div className={styles.list}>
      {new_members?.length > 0 &&
        new_members.map((member, index) => {
          const isLastMember = new_members.length === index + 1
          const workplace = Object.values(workplaces).find((wp) => wp.id === member.workplace_id)
          return (
            <div key={member.id} className={styles.member} ref={isLastMember ? lastMemberRef : null}>
              <Avatar
                key={'member_' + member.user_id}
                imgWrapperSize='small'
                userId={member.user_id}
                profilePicture={member.profile_picture}
                firstname={member.firstname}
                lastname={member.lastname}
                mimeType={member.mime_type}
                originalTag={member.original_tag}
                isOriginal={member.is_original}
                userStatus={member.status}
                withExpertiseGroup={member.with_expertise_group}
                onClickAction={() => {
                  showUserModal(member.user_id)
                }}
              />
              <div className={styles.userProfile}>
                <div className={styles.memberName}>
                  {member.status === 'deleted' ? t('global.deletedUser') : `${member.firstname} ${member.lastname}`}
                </div>
              </div>
              <WorkplaceTile
                workplaceId={workplace.id}
                workplaceName={workplace.name}
                color={workplace.color}
                initials={workplace.initials}
                size='tiny'
                className={styles.tileWrapper}
                tileClassName={styles.tile}
                isNative={isNative}
              />
            </div>
          )
        })}
      {loading && <Spinner />}
    </div>
  )
}

export default CTANewMembersFull
